import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Avatar, AttachedDocumentDownload} from 'shared/components';
import EntryRightMenu from './EntryRightMenu';

const UploadEntry = ({detailsState, entry}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm'/>
      <div className='flex-1'>
        <div className='flex justify-between'>
          <div>
            <div className='flex items-center gap-2'>
              <div className='h3 medium'>
                <FormattedMessage id='recruiting.hiring_funnel.Internal Documents'/>
              </div>
              <div className='h5 jumbo'>{entry.date}</div>
            </div>
            <div className='h5 jumbo'>{entry.name}</div>
          </div>
          <EntryRightMenu detailsState={detailsState} entry={entry}/>
        </div>
        <div className='pt2 whitespace-pre-line'>
          {entry.text}
        </div>
        <div className='mt2 space-y'>
          {entry.attachments.map(attachment => <AttachedDocumentDownload key={attachment.id} doc={attachment}/>)}
        </div>
      </div>
    </div>
  );
};

export default observer(UploadEntry);
